































import Vue from 'vue';
import { IMenuItem, IMobileMenuAccountComponent } from '@/common/interfaces/header.interface';
import MobileMenuBack from './MobileMenuBack.vue';
import MobileMenuEntry from './MobileMenuEntry.vue';

export default Vue.extend({
  name: `MobileAccount`,
  components: { MobileMenuBack, MobileMenuEntry },
  data(): IMobileMenuAccountComponent {
    return {
      opened: false,
    };
  },
  computed: {
    backText(): string {
      return this.$t(`header:backText`);
    },
  },
  props: {
    loggedIn: {
      required: true,
      type: Boolean,
    },
    topics: {
      required: true,
      type: Array as () => IMenuItem[],
    },
  },
  methods: {
    toggleAccountMenu(): void {
      this.opened = !this.opened;
      this.$emit(`changed:state`, this.opened);
    },
  },
});
